import endpoint from "../../config/endpoints";
export const WeeklyOffJsonNew = {
  showSaveNextBtn: true,
  apiBaseURL: endpoint.weeklyOfUserWise,
  formPath: "/weekly-off-form-new",
  formPathView: "/weekly-off-view",
  screenTitle: "Weekly Off Management",
  showTitle: true,
  showCancel: false,
  showSaveBtn: false,

  tableColumnsToFilter: [
    {
      columnDisplayName: "Employee Code",
      columnKeyName: "employeeCode",
      isChecked: true,
    },
    {
      columnDisplayName: "Sales Person Name",
      columnKeyName: "name",
      isChecked: true,
    },
    {
      columnDisplayName: "Designation",
      columnKeyName: "designation",
      isChecked: true,
    },
    {
      columnDisplayName: "Weekly Off Days",
      columnKeyName: "dayName",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "Sales Team ",
      controlType: "multiSelect",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "salesExecutiveDetail",
      dataKey: "salesTeam",
      isRootLevelKey: false,
      isMandatory: true,
    },
  ],

  fieldMetaNew: [],
};
